<template>
    <v-container>
        <h3>
            {{ files.length }} file(s) imported. Please drag each file to the corresponding
            {{ containerType }}.
        </h3>
        <v-row style="padding-top: 16px; padding-left: 18px; padding-right: 32px">
            <v-col cols="6">
                <h3>Files</h3>
                <v-chip
                    v-for="(file, index) in files"
                    :key="file.name"
                    :draggable="!disabledChips[index]"
                    @dragstart="draggedData = file.name"
                    :color="disabledChips[index] ? 'grey' : 'primary'"
                    :style="{
                        margin: '4px',
                        cursor: disabledChips[index] ? 'not-allowed' : 'grab',
                    }"
                >
                    {{ file.name }}
                </v-chip>
            </v-col>
            <v-col cols="6">
                <v-form>
                    <div v-for="group in Object.keys(groupsToContainersMap)" :key="group">
                        <h3>{{ group }}</h3>
                        <div v-for="container in groupsToContainersMap[group]" :key="container">
                            <v-label class="label" style="display: flex; align-items: center">
                                <v-text-field
                                    v-model="containerMap[container]"
                                    @drop="onDrop($event, container)"
                                    @dragover.prevent
                                    class="text-field"
                                ></v-text-field>
                                <v-icon @click="clearMapping(container)" style="cursor: pointer"
                                    >$close</v-icon
                                >
                                <span style="margin-left: 8px">{{ container }}</span>
                            </v-label>
                        </div>
                    </div>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { EventBus } from "@/lib/event-bus";

export default {
    name: "MapFilesToContainers",
    props: {
        files: Array,
        groupsToContainersMap: Object,
        containerType: String,
    },
    data() {
        return {
            draggedData: null,
            containerMap: {},
            disabledChips: [],
        };
    },
    methods: {
        onDrop(event, container) {
            this.containerMap[container] = this.draggedData;
            this.disabledChips = this.files.map((file) =>
                Object.values(this.containerMap).includes(file.name)
            );
            this.mappingChanged();
        },
        clearMapping(container) {
            const mappedFile = this.containerMap[container];
            const mappedIndex = this.files.findIndex((file) => file.name === mappedFile);
            this.disabledChips = [...this.disabledChips]; // Create a new array or the UI won't update
            this.disabledChips[mappedIndex] = false;
            this.containerMap[container] = ""; // Clear the mapping
            this.mappingChanged();
        },
        mappingChanged() {
            this.$emit("mappingChanged", this.containerMap);
        },
    },
};
</script>
